console.log('IWT Carousel JS loaded');

class IwtCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-iwt-track]');
    this.slides = Array.from(root.querySelectorAll('[data-iwt-slide]'));
    this.dots = Array.from(root.querySelectorAll('[data-iwt-dot]'));
    this.index = 0;

    this.autoplay = root.dataset.autoplay === 'true';
    this.interval = parseInt(root.dataset.interval, 10) || 3000;

    console.log('IWT Carousel init:', {
      slides: this.slides.length,
      autoplay: this.autoplay,
      interval: this.interval
    });

    if (!this.track || this.slides.length < 2) {
      console.log('Not enough slides or track missing');
      return;
    }

    // Set proper widths
    const containerWidth = this.root.offsetWidth;
    this.slides.forEach(slide => {
      slide.style.width = containerWidth + 'px';
    });

    // Bind dot clicks
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.stop();
        this.goTo(i);
        if (this.autoplay) this.start();
      });
    });

    this.goTo(0);
    this.updateDots();
    
    if (this.autoplay) this.start();
  }

  goTo(i) {
    this.index = (i + this.slides.length) % this.slides.length;
    const containerWidth = this.root.offsetWidth;
    const offset = this.index * containerWidth;
    console.log('Going to slide', this.index, 'offset:', offset);
    this.track.scrollLeft = offset;
    this.updateDots();
  }

  updateDots() {
    this.dots.forEach((dot, i) => {
      if (i === this.index) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
    console.log('Carousel started');
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      console.log('Carousel stopped');
    }
  }
}

function initIwtCarousels(container = document) {
  console.log('Initializing carousels in:', container);
  container.querySelectorAll('[data-iwt-carousel]').forEach((el) => {
    if (el.__iwtCarousel) {
      el.__iwtCarousel.stop();
      el.__iwtCarousel = null;
    }
    el.__iwtCarousel = new IwtCarousel(el);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, init carousels');
  initIwtCarousels(document);
});

document.addEventListener('shopify:section:load', (event) => {
  console.log('Section loaded');
  initIwtCarousels(event.target);
});

document.addEventListener('shopify:section:reorder', (event) => {
  console.log('Section reordered');
  initIwtCarousels(event.target);
});

// Re-init on window resize to fix widths
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    initIwtCarousels(document);
  }, 250);
});
